module.exports = __webpack_public_path__ + "media/application/images/icons/download-file-f95135d3bd36b15b038271e133831327.svg";